import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const AnalyzingOverlay = ({ messages, text }) => {
  const list = messages || [text || "L'agente sta analizzando le tue transazioni…"];
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (list.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % list.length), 2400);
    return () => clearInterval(t);
  }, [list.length]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/75 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
        className="mx-6 w-full max-w-[320px] rounded-[12px] border border-white/[0.08] bg-[#0D0D14] p-7 text-center shadow-[0_0_0_1px_rgba(0,255,135,0.12)]"
      >
        <div className="flex items-center justify-center gap-2">
          <span className="liqo-thinking-dot !h-2 !w-2" />
          <span className="liqo-thinking-dot !h-2 !w-2" />
          <span className="liqo-thinking-dot !h-2 !w-2" />
        </div>
        <p className="mono mt-5 min-h-[40px] text-[13px] font-light leading-5 text-white/85" data-testid="loading-analyzing-text">
          {list[idx]}
        </p>
        <p className="caps-tag mt-2 text-white/30">Agente AI al lavoro</p>
      </motion.div>
    </div>
  );
};
